module.exports = __webpack_public_path__ + "static/media/badger-honey.8350d033.svg";